import { render } from "./PillToggle.vue?vue&type=template&id=c60b38ec"
import script from "./PillToggle.vue?vue&type=script&lang=js"
export * from "./PillToggle.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__